var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6063 1.875C16.5324 1.875 18.125 3.39631 18.125 5.31089C18.125 6.2804 17.7059 7.2009 16.9773 7.84972L14.2668 10.2632C13.5366 10.9134 13.125 11.8271 13.125 12.78V16.2612C13.125 17.8121 11.3454 18.6392 10.1175 17.7717L8.49982 16.6289C7.74489 16.0956 7.29167 15.238 7.29167 14.3181V12.8767C7.29167 11.8769 6.83865 10.9225 6.04457 10.2698L3.11096 7.8586C2.33024 7.21689 1.875 6.26901 1.875 5.265C1.875 3.37577 3.44647 1.875 5.34647 1.875H14.6063Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.2bbbd349341faaa0c500c591656c5d3c.svg";
export { ForwardRef as ReactComponent };